import Autocomplete from '@mui/material/Autocomplete';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import React from 'react';

const DropdownAutocomplete = ({
  dropdownData,
  multiSelect = true,
  dropdownTitle,
  value,
  handleOnChange,
  placeholder,
  sx = { width: '100%', backgroundColor: 'white' },
  size = 'small',
  label = null,
  id = null,
  avatar = null,
  renderAvatar = true,
  renderOption = null,
  handleBlur = () => {},
}) => {
  const handleDelete = itemToDelete => {
    if (multiSelect && value) {
      const filteredSendData = value.filter(
        item => item[id] !== itemToDelete[id]
      );
      handleOnChange(filteredSendData);
    } else {
      handleOnChange(null);
    }
  };

  const handleChange = item => {
    handleOnChange(item);
  };

  return (
    <div>
      <FormControl sx={sx}>
        <Autocomplete
          size={size}
          multiple={multiSelect}
          id="multiple-limit-tags"
          options={dropdownData}
          onChange={(e, item) => handleChange(item)}
          onBlur={handleBlur}
          value={value}
          getOptionLabel={option => option[label]}
          renderTags={tagValue =>
            tagValue.map((val, i) => {
              return (
                <Chip
                  avatar={
                    avatar ? (
                      <Avatar key={`${val[id]}-${i}`} src={val[avatar]} />
                    ) : (
                      <></>
                    )
                  }
                  key={i}
                  onDelete={() => handleDelete(val)}
                  label={val[label]}
                />
              );
            })
          }
          renderOption={(props, option) => {
            return (
              <li {...props}>
                {renderAvatar && multiSelect && (
                  <Avatar
                    src={option[avatar]}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                )}
                {(renderOption && renderOption(props, option)) || (
                  <span>{option[label]}</span>
                )}
              </li>
            );
          }}
          renderInput={params => (
            <TextField
              placeholder={((!value || !value.length) && placeholder) || ''}
              label={dropdownTitle}
              {...params}
            />
          )}
          sx={sx}
        />
      </FormControl>
    </div>
  );
};

export default DropdownAutocomplete;
